import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { orderReturnService } from '@kss/api';
import type { OrderReturnCreate } from '@kss/api';
import { loadSalesOrderOptions } from '../shared/formLoaders';

const columns: BulkColumn<OrderReturnCreate>[] = [
  { key: 'returnNumber', header: 'Return #', required: true, sample: 'RET-1001' },
  { key: 'returnDate', header: 'Date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'salesOrderId', header: 'Sales order', required: true, dataType: 'lookup', loadOptions: loadSalesOrderOptions },
  { key: 'reason', header: 'Reason' },
  { key: 'totalAmount', header: 'Total', dataType: 'number', parse: parseNum as never },
  { key: 'refundAmount', header: 'Refund', dataType: 'number', parse: parseNum as never },
  { key: 'status', header: 'Status', sample: 'Requested' },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkOrderReturn() {
  return (
    <BulkSpreadsheet<OrderReturnCreate> title="Bulk import order returns" entityLabel="return" backPath="/panel/order-returns" columns={columns} module="OrderReturn"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await orderReturnService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
